import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Success' },
    { value: 1, label: 'Debug' },
    { value: 2, label: 'Info' },
    { value: 3, label: 'Warning' },
    { value: 4, label: 'Error' },
  ],
});
